import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import HelpDialog from './Common/HelpDialog';

interface AppHeaderProps {
  sidebarOpen: boolean;
  onToggleSidebar: () => void;
}

const AppHeader = ({ sidebarOpen, onToggleSidebar }: AppHeaderProps) => {
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <header className="app-header">
      <div className="logo-group">
        <div className="logo">ideo<em>chrom</em></div>
        <div className="logo-subtitle">Last Updated {BUILD_DATE}</div>
      </div>
      <div className="header-right">
        <button
          className="sidebar-toggle"
          onClick={onToggleSidebar}
          aria-label="Toggle options panel"
        >
          {sidebarOpen ? '✕ Close' : '☰ Options'}
        </button>
        <button className="btn" onClick={() => setContactOpen(true)}>
          ✉ Contact
        </button>
        <form
          action="https://www.paypal.com/donate"
          method="post"
          target="_top"
          style={{ display: 'inline' }}
        >
          <input type="hidden" name="business" value="GL7VZ4W9KEAXL" />
          <input type="hidden" name="no_recurring" value="0" />
          <input type="hidden" name="item_name" value="Help keep this site going by donating! Every bit counts! Thank you!" />
          <input type="hidden" name="currency_code" value="USD" />
          <button type="submit" className="btn btn-donate">♥ Donate</button>
        </form>
        <HelpDialog />
      </div>

      <Dialog open={contactOpen} onClose={() => setContactOpen(false)}>
        <DialogTitle>Contact</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Have questions or issues? Feel free to reach out!
          </DialogContentText>
          <a href="mailto:admin@ideochrom.com" style={{ color: 'var(--accent)' }}>
            admin@ideochrom.com
          </a>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setContactOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </header>
  );
};

export default AppHeader;
